import ConfigParameter, { gettext } from "../ConfigParameter";

export default class Analytics extends ConfigParameter {

    constructor() {
        super(
            'analytics',
            'checkbox',
            gettext('Enable event tracking'),
            'analytics',
            true,
            null,
            null,
            null,
            null,
            gettext('Event tracking uses Google Analytics. Check global page settings to enable your GA key.'));
    }

}


// WEBPACK FOOTER //
// ./src/cmsCore/Creator/ConfigParameters/ConfigParameters/Analytics.js